import { http } from 'connex-cds';

export default {
  paragonMigrate: ({ entityRef, data }) => http.post({ apiName: 'dexa', path: `/paragon/${entityRef}/migrate`, data }),
};
